import { LanguageSelect, LocaleFormat, useBookkeepingCategories } from '@components'

import { Space } from '@billy/design-system'
import { useCallback, useState } from 'react'
import ReactJson from 'react-json-view'

export const BookkeepingCategories = () => {
  const [selectedLanguage, setSelectedLanguage] = useState<LocaleFormat | undefined>('da_DK')

  const { suggestedCategories } = useBookkeepingCategories({
    locale: selectedLanguage as LocaleFormat,
    isEnabled: true,
  })

  const handleLanguageChange = useCallback((language: LocaleFormat | undefined) => {
    setSelectedLanguage(language)
  }, [])

  return (
    <>
      <Space />
      <LanguageSelect
        id="bookkeeping-categories-language-select"
        onSelect={(value) => {
          handleLanguageChange(value)
        }}
        withSearch={false}
        dropdownSize="fitTrigger"
        selectedId={selectedLanguage}
      />
      <Space />
      <ReactJson src={suggestedCategories} name={null} indentWidth={2} collapsed={3} />
    </>
  )
}
